import {
  Component,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ChartTypes } from '@mode/shared/contract-common';
import { DropdownItem } from '../dropdown/dropdown-list.component';

const enum ScaleNames {
  Linear = 'Linear',
  Log = 'Logarithmic',
}

@Component({
  selector: 'mode-format-builder-scale',
  templateUrl: './scale.component.html',
  styleUrls: ['./scale.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScaleComponent implements OnInit, OnChanges {
  @Input() axisScale: ChartTypes.AxisScaleTypeFormat = { type: ChartTypes.AxisScaleTypes.Linear };
  @Output() update = new EventEmitter<ChartTypes.AxisScaleTypeFormat>();

  menuItems: Array<DropdownItem> = [{ name: ScaleNames.Linear }, { name: ScaleNames.Log }];
  selected: DropdownItem | undefined = this.menuItems[0];

  ngOnInit() {
    this.selected = this.getScaleName(this.axisScale);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.selected = this.getScaleName(changes.axisScale?.currentValue);
  }

  /**
   * @description Handle scale selection, emitting the new
   * AxisScaleTypeFormat properties per the selection
   */
  selectItem(item: DropdownItem) {
    this.selected = item;
    this.axisScale = this.makeAxisScaleTypeFormat(item);
    this.update.emit(this.axisScale);
  }

  private getScaleName(axisScale: ChartTypes.AxisScaleTypeFormat) {
    const scale = axisScale?.type === ChartTypes.AxisScaleTypes.Log ? ScaleNames.Log : ScaleNames.Linear;
    return this.menuItems.find((item) => item.name === scale);
  }

  private makeAxisScaleTypeFormat(item: DropdownItem) {
    if (item.name === ScaleNames.Log) {
      return {
        type: ChartTypes.AxisScaleTypes.Log,
        base: 10,
      };
    }
    return {
      type: ChartTypes.AxisScaleTypes.Linear,
    };
  }
}
